import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { DesignBlockData } from "../../../base-design-block-modal/types/base-design-block.types";
import { defaultDesignBlockData } from "../../../base-design-block-modal/configs/default-design-block-data";
import { ModalsService } from "../../../../../../../../core/services/modals.service";
import { DesignBlockFileActionButton } from "../../../design-block-files-modal/types/design-block-files.types";
import { FilesService } from "../../../../../../../../core/services/files.service";
import { ListingFilesStateService } from "../../services/listing-files-state.service";
import { LoadingService } from "../../../../../../../../core/services/loading.service";
import { ListingShowFileLibraryStateService } from "../../services/listing-show-file-library-state.service";
import { ErrorService } from "../../../../../../../../core/services/error.service";
import { MatIconButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { MatTooltip } from "@angular/material/tooltip";

@Component({
  selector: 'div[app-lf-header-modal]',
  standalone: true,
  imports: [
    MatIconButton,
    MatIcon,
    MatTooltip
  ],
  templateUrl: './lf-header-modal.component.html',
  styleUrl: './lf-header-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LfHeaderModalComponent {
  designBlockData = input<DesignBlockData>(defaultDesignBlockData);
  columnKey = input<string>('');
  isActiveUploadFile = input<boolean>(false);
  uploadFiles = output<boolean>();

  private modalService: ModalsService = inject(ModalsService);
  private filesService: FilesService = inject(FilesService);
  private errorService: ErrorService = inject(ErrorService);
  private listingFilesStateService: ListingFilesStateService = inject(ListingFilesStateService);
  private loadingService: LoadingService = inject(LoadingService);
  private listingShowFileLibraryStateService: ListingShowFileLibraryStateService = inject(ListingShowFileLibraryStateService);

  public isShowFileLibrary = computed(() => this.listingShowFileLibraryStateService.isShowFileLibrary());

  public async handleClick(key: DesignBlockFileActionButton): Promise<void> {
    const actionMap = {
      history: () => this.openHistoryModal(),
      upload: () => this.handelUpload(),
      download: () => this.openDownloadModal(),
      showFileLibrary: () => this.handelShowFileLibrary()
    } as const;

    await actionMap[key]?.();
  }

  private async openHistoryModal(): Promise<void> {
    this.modalService.openHistoryChangesModal({
      historyChangesData: this.designBlockData().history,
      columnKey: this.columnKey()
    });
  }

  private handelUpload() {
    if (this.listingFilesStateService.listingFilesState().length >= 99) {
      this.errorService.showErrorMessage('Максимальное количество файлов достигнуто. Удалите лишние файлы, чтобы освободить место для новых.');
      return;
    }

    this.uploadFiles.emit(!this.isActiveUploadFile());
  }

  private async openDownloadModal(): Promise<void> {
    const fileIds = this.listingFilesStateService.listingFileIds();
    this.loadingService.setIsLoadingState(true);
    await this.filesService.downloadArchiveFiles(fileIds)
      .finally(() => this.loadingService.setIsLoadingState(false));
  }

  private handelShowFileLibrary(): void {
    this.listingShowFileLibraryStateService.toggleShowFileLibrary();
  }
}
